/**
 * Сервис утилит для работы с массивами: разбиение на части, группировка и т.д.
 */
export class ArrayService {
  /**
   * Разбивает массив на подмассивы (чанки) фиксированного размера.
   * Последний чанк может содержать меньше элементов, если длина массива не кратна size.
   *
   * @param arr - Исходный массив произвольного типа
   * @param size - Максимальное количество элементов в одном чанке (положительное целое)
   * @returns Массив чанков: каждый элемент — массив не более чем из `size` элементов.
   *          Пример: chunkArray([1, 2, 3, 4, 5], 2) → [[1, 2], [3, 4], [5]]
   *
   * @example
   * chunkArray([1, 2, 3, 4, 5], 2)   // [[1, 2], [3, 4], [5]]
   * chunkArray(['a', 'b'], 10)        // [['a', 'b']]
   * chunkArray([], 3)                 // []
   */
  public static chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }
}
